import Header from 'src/components/layout/Header';
import Footer from 'src/components/layout/Footer';
import Router from 'src/Router';
import { Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";
import store, {persistor} from "src/store/store";
import { PersistGate } from "redux-persist/integration/react";

import ChannelPreviewModal from 'src/components/modal/ChannelPreviewModal';
import PdfImageModal from "src/components/modal/PdfImageModal";
import ExplainModal from "src/components/modal/ExplainModal";
import InquiryModal from "src/components/modal/InquiryModal";
import CompleteModal from "src/components/modal/CompleteModal";


function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <HelmetProvider>
          <AppContent />
        </HelmetProvider>
      </PersistGate>
    </Provider>
  );
}

function AppContent() {
  return (
    <>
      <Header />
      <Router />
      <Footer />
      <ExplainModal />
      <InquiryModal />
      <PdfImageModal />
      <CompleteModal /> 
      <ChannelPreviewModal />
    </>
  );
}
export default App;
